import i18next from "../../../../i18n";

i18next.addResources("en", "EntitySelect", {
    placeholder: "Select entity",
});
i18next.addResources("fr", "EntitySelect", {
    placeholder: "Sélectionner une entité",
});
